import React, { Component } from 'react';
import Firebase from 'firebase';




class addStore extends Component {
    constructor() {
        super();
        this.state = {
            id: "",
            name: "",
            address: "",
            comuna: ""
        }
        this.setFirebase = this.setFirebase.bind(this);
    }

    componentWillMount() {

    }



    setFirebase() {
        var storeRef = Firebase.database().ref('stores').child(localStorage.client_id);
        var id = this.state.id;
        storeRef.child(id).set({
            "address": this.state.address,
            "comuna": this.state.comuna,
            "name": this.state.name
        }).then(resp => {
        });
        this.props.callBack();
    }

    render() {
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="ccnumber">Codigo local</label>
                        <input type="text" className="form-control" id="inputCodloc"
                            placeholder="codigo del nuevo local"
                            value={this.state.codloc}
                            onChange={(e) => { this.setState({ id: e.target.value }) }} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="ccnumber">Nombre</label>
                        <input type="text" className="form-control" id="inputName"
                            placeholder="nombre del nuevo local"
                            value={this.state.name}
                            onChange={(e) => { this.setState({ name: e.target.value }) }} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="ccnumber">Dirección</label>
                        <input type="text" className="form-control" id="inputAddress"
                            placeholder="direccion del nuevo local"
                            value={this.state.address}
                            onChange={(e) => { this.setState({ address: e.target.value }) }} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="ccnumber">Comuna</label>
                        <input type="text" className="form-control" id="inputComuna"
                            placeholder="Comuna del nuevo local"
                            value={this.state.comuna}
                            onChange={(e) => { this.setState({ comuna: e.target.value }) }} />
                    </div>
                    <div className="text-right">
                        <a  className="btn btn-success" onClick={() => { this.setFirebase()}} >Crear</a>
                    </div>
                </div>
            </div>
        );
    }
}
export default addStore;



// WEBPACK FOOTER //
// ./src/views/stores/addStore.js